import styled from "styled-components";
import { media } from "../../theme/theme";
import { MarketingSpacing } from "../ReusableStyledComponents/MarketingSpacing";
import { Body, H1 } from "../Typography";

export const MarketingUseCaseHeaders = styled.div<{ useAuthoryFor: boolean, customImageMaxWidth?: number, customRightComponentMargin?: string }>`
    display: flex;
    max-width: 1440px;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    margin-bottom: 80px;

    ${media.tablet}{
        flex-wrap: nowrap;
        margin-bottom: 15px;
    }

    ${media.desktop}{
        align-items: center;
        margin-bottom: 0;
    }

    > div {
        width: 100%;
        text-align: center;

        ${media.tablet}{
            text-align: left;
            width: initial;
        }

        &:first-child {
            margin-bottom: 0;
            ${MarketingSpacing}

            ${media.desktop}{
                margin: ${({ useAuthoryFor }) => useAuthoryFor ? "0 auto 65px" : "0 auto"};
            }
        }

        &:nth-child(2) {
            ${media.tablet}{
                position: relative;
                width: 100%;
                max-width: ${({ useAuthoryFor, customImageMaxWidth }) => customImageMaxWidth ? `${customImageMaxWidth}px` : useAuthoryFor ? "720px" : "550px"};
                margin: ${({ customRightComponentMargin }) => customRightComponentMargin ? customRightComponentMargin : undefined};
            }
        }

        ${H1} {
            margin-bottom: 25px;
            font-weight: ${({ theme }) => theme.typography.weight.regular};

            ${media.desktop}{
                margin-bottom: 40px;
            }
        }

        ${Body} {
            color:  ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
        }
    }
`;

export const LightTitleSection = styled.span`
    font-weight: 300;
    font-size: 48px;
    line-height: 57px;
`;

export const UseCaseSVG = styled.svg`
    width: 100%;
    height: auto;
`;

export const MarketingUserCaseText = styled.div`
    max-width: 550px;
    margin: 0 auto;

    ${media.custom(1150)} {
        margin-top: 20px;
    }
`;

export const DesktopImage = styled.div`
    display: none;

    ${media.tablet} {
        display: block;
    }
`;

export const MobileImage = styled.div`
    display: block;

    ${media.tablet} {
        display: none;
    }
`;

export const ButtonWrapper = styled.div`
    margin-bottom: 32px;
    
    ${media.tablet} {
        margin-bottom: 0;
    }
`;

export const ImageContainer = styled.div<{ maxWidth?: number }>`
    position: relative;
    max-width: 400px;
    margin: 0 auto;

    ${media.tablet}{
        max-width: ${({ maxWidth }) => maxWidth ? `${maxWidth}px` : "initial"};
        margin: initial;
    }
`;

export const UseCaseLink = styled.a`
    text-decoration: underline;
    cursor: pointer;
    text-decoration-color: ${({ theme }) => theme ? `${theme.marketing.colors.blackPearl70}` : null};
`;